import React from 'react'
import ReactDOM from 'react-dom'
import App from './app'
import Amplify from 'aws-amplify'
import * as serviceWorker from './serviceWorker'

import 'bootstrap/dist/css/bootstrap.min.css'
import './css/css'

import config from './config/config'
import "./i18n/config"

Amplify.configure(config)

if (process.env.REACT_APP_STAGE === "main") {
    document.oncontextmenu = function () { return false; }
}

const root = document.getElementById('root')
ReactDOM.render(<App />, root)

serviceWorker.unregister()
